module.exports = "/_next/static/images/cw-7dbea206d4d61e620bfdea0fea27ac69.svg";